import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

import DialogActions from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogActions';
import DataContainer from 'Components/UI/DataContainer';
import useCollection from 'Hooks/useCollection';

import DialogContent from './DialogContent';
import DialogTitle from './DialogTitle';

const DialogContainer = ({ financialWellnessScoreLink, componentName }) => {
  const { collection, setCollection } = useCollection();
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);

  async function fetchData() {
    try {
      const coll = await fr.http.get(financialWellnessScoreLink);

      setCollection(coll);
    } catch (err) {
      setLoadingError(err);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const componentResource = collection?.resources().head()
    .attr('components').resources()
    .list()
    .find(v => v.attr('type') === componentName);

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while loading.',
      }}
    >
      <DialogTitle
        componentResource={componentResource}
      />
      <DialogContent
        componentResource={componentResource}
      />
      <DialogActions />
    </DataContainer>
  );
};

DialogContainer.propTypes = {
  financialWellnessScoreLink: PropTypes.string.isRequired,
  componentName: PropTypes.string.isRequired,
};

export default DialogContainer;
